import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { AddressDisplay } from '@vp/address-display';
import {
  anyItemContainsShippingAddressEditRestrictions,
  UpdateShippingAddressButton,
} from '../../shared/addresses/UpdateShippingAddressButton';
import { AddressType } from '../../../constants/addressType';
import useSiteData from '../../../hooks/useSiteData';
import useIdentityContext from '../../../hooks/useIdentityContext';
import { OrderDetailsContext } from '../../contexts/OrderDetailsContext';
import { areAnyItemsShipped } from '../../../util/mapStateToStatus';
import { OrderDetailsCardHeading } from './OrderDetailsCardHeading';

export const AddressDetail = ({ address, title, addressType }) => {
  const { identity } = useIdentityContext();
  const { isAnonymousUser } = identity;

  const { customerEditShippingAddressEnabled, locale } = useSiteData();

  const { order } = useContext(OrderDetailsContext);
  const orderContainsShippedItems = areAnyItemsShipped(order);

  const hasShippingAddressEditRestriction =
    anyItemContainsShippingAddressEditRestrictions(order);

  // TODO: See if we should extract isShippingAddressEditable to shipping details component

  // shipping address is only editable if:
  // 1. site is configured to allow the feature
  // 2. order has not already started to be shipped
  // 3. order was not placed anonymously
  // 4. order does not have any item with a shipping address edit restriction
  const isShippingAddressEditable =
    !orderContainsShippedItems &&
    address &&
    addressType === AddressType.SHIPPING &&
    customerEditShippingAddressEnabled &&
    !isAnonymousUser &&
    !hasShippingAddressEditRestriction;

  return (
    <>
      <OrderDetailsCardHeading testId="card-title">
        {title}
      </OrderDetailsCardHeading>

      <AddressDisplay address={address} locale={locale} />

      {isShippingAddressEditable && (
        <div className="noprint">
          <UpdateShippingAddressButton
            address={address}
            addressType={AddressType.SHIPPING}
          />
        </div>
      )}
    </>
  );
};

AddressDetail.propTypes = {
  address: PropTypes.object.isRequired,
  title: PropTypes.string,
  addressType: PropTypes.string.isRequired,
};
